export default __webpack_public_path__ + "static/cs462-2cbaa58b16d9e6a16ee9af65423ececc.png";